export const DATE_RANGE = 'dateRange';
export const SINGLE_DATE = 'singleDate';
